import axios from 'axios';
import { error_message } from '../components/Toastr';
import { GetUserTennantCanonicalName } from '../hooks/auth';
import * as Form from './api/form';
import * as Location from './api/location';
import * as Workflow from './api/workflow';
import * as FormTask from './api/formTask';
import * as User from './api/User';
import * as ListTree from './api/ListTree';
import * as ListTreeItem from './api/ListTreeItem';

const tennantCanonicalName = GetUserTennantCanonicalName();
const baseUrl = getTennantApiUrl(tennantCanonicalName);
const apimSubscriptionKey = '5ae8fa8330ad40a7bfe4b8faf08727c5';// process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY;

const defaultHeaders = {};

if (tennantCanonicalName) {
  defaultHeaders.tenant = tennantCanonicalName;
  // Api.defaults.headers.common.tenant = tennantCanonicalName;
}

if (apimSubscriptionKey) {
  defaultHeaders['Ocp-Apim-Subscription-Key'] = apimSubscriptionKey;
}

// if (baseUrl) {
//   Api.defaults.baseURL = baseUrl;
// }

const Api = axios.create({
  baseURL: baseUrl, //this is undefined if the user is not logged
  headers: defaultHeaders,
});

export default Api;

// This export is deprecated, please use Api_v2
export { Form, Location };

export const Api_v2 = {
  Form,
  Location,
  Workflow,
  FormTask,
  User,
  ListTree,
  ListTreeItem,
};

export function SetApiBaseUrl(tennantCanonicalName) {
  const baseURL = getTennantApiUrl();
  Api.defaults.baseURL = baseURL;

  if (apimSubscriptionKey) {
    Api.defaults.headers['Ocp-Apim-Subscription-Key'] = apimSubscriptionKey;
  }

  if (tennantCanonicalName) {
    Api.defaults.headers.common.tenant = tennantCanonicalName;
  }
}

function getTennantApiUrl() {
    return process.env.REACT_APP_API_BASE_URL;
}

export const APIWithOutTenant = async (
  url,
  tenant,
  typeRequest,
  headers,
  data
) => {
  SetApiBaseUrl(tenant);
  let linktenant = getTennantApiUrl(tenant);
  if (typeRequest.toUpperCase() == 'POST') {
    return Api.post(linktenant + url, headers, data);
  } else {
    return Api.get(linktenant + url, headers, data);
  }
};

export const exceptionNotificationAPI = (error) => {
  console.error(error);

  try {
    if (/500/.test(error.message)) {
      error_message('Failed to connect Web Service (500)');
    } else if (/403/.test(error.message)) {
      error_message('Unauthorized access (403)');
    } else if (/404/.test(error.message)) {
      error_message('Route Not Found (404)');
    } else if (/400/.test(error.message)) {
      let notifications = error.response.data.notifications;
      if (notifications && notifications.length > 0) {
        notifications.forEach((not) => {
          error_message(not.message);
        });
      }
    } else {
      error_message(error.message);
    }
  } catch {
    error_message('Please inform catch object!');
  }
};

export const locationGetAll = Location.getAll;
export const locationGetAllSimple = Location.getAllSimple;
export const getLocationByCompanyId = Location.getLocationByCompanyId;

export const getUserCompanyByUserId = async (userId = '') => {
  const result = await Api.get(
    `/User/getUserCompanyIdByUser?userId=${userId}`
  );
  return result.data.response;
};

/**
 *
 * @param {string} ListTreeItems ListTreeId
 */
export const treeListItemsGetAll = async (ListTreeId = '') => {
  const result = await Api.post(
    `/ListTree/items/getAll?ListTreeId=${ListTreeId}`
  );
  return result;
};

export const originItemsGetAll = async (OriginInformationId = '') => {
  const result = await Api.post(`/OriginInformation/getItemsById`, { originInformationId: OriginInformationId });
  return result;
};

/**
 *
 * @param {string} ListTree
 */
export const treeListGetAll = async (searchLocation = '', searchTopic = '') => {
  let searchFilter = {
    locationId: searchLocation,
    topicId: searchTopic,
    searchText: '',
    status: '',
    orderField: 'name',
    ascendingOrder: false,
    pageNumber: 1,
    pageSize: 10,
  };
  const result = await Api.post(`/ListTree/getAll`, searchFilter);
  return result;
};

/**
 *
 * @param {string} id
 * @param {string} languageId
 */
export const treeListGetById = async (id, languageId = '') => {
  return Api.get(`ListTree/get?id=${id}&languageId=${languageId}`);
};

export const treeListUpdateTranslations = async (
  languageId,
  listId,
  name,
  description,
  items = []
) => {
  return Api.post(`ListTree/updateTranslation`, {
    languageId,
    listId,
    name,
    description,
    items,
  });
};

export const locationUpdateTranslations = Location.locationUpdateTranslations;

/**
 *
 * @param {string} locationId
 * @param {string} topicId
 * @param {string} searchText
 * @param {string} status
 * @param {string} orderField
 * @param {boolean} ascendingOrder
 * @param {number} pageNumber
 * @param {number} pageSize
 */
export const topicGetAll = async (
  locationId = '',
  topicId = '',
  searchText = '',
  status = '',
  orderField = '',
  ascendingOrder = true,
  pageNumber = 0,
  pageSize = 0
) => {
  const result = await Api.post('/Topic/getAll', {
    locationId: locationId,
    topicId: topicId,
    searchText: searchText,
    status: status,
    orderField: orderField,
    ascendingOrder: ascendingOrder,
    pageNumber: pageNumber,
    pageSize: pageSize,
  });

  return result;
};

export const getTopics = async () => {
  const result = await Api.post('/Topic/getTopics', null);
  return result;
};

export const getTopicsByProfile = async () => {
  const result = await Api.post('/Topic/getTopicsByProfile', null);
  return result;
};

/**
 *
 * @param {string} locationId
 * @param {string} topicId
 * @param {string} searchText
 * @param {string} status
 * @param {string} orderField
 * @param {boolean} ascendingOrder
 * @param {number} pageNumber
 * @param {number} pageSize
 */
export const topicGetAllSimple = async (
  locationId = '',
  topicId = '',
  searchText = '',
  status = '',
  orderField = '',
  ascendingOrder = true,
  pageNumber = 0,
  pageSize = 0
) => {
  const result = await Api.post('/Topic/getAllDropdown', {
    locationId: locationId,
    topicId: topicId,
    searchText: searchText,
    status: status,
    orderField: orderField,
    ascendingOrder: ascendingOrder,
    pageNumber: pageNumber,
    pageSize: pageSize,
  });

  return result;
};

/**
 * @typedef {Object} topicUpdateParams
 * @property {string} topicId
 * @property {string} languageId
 * @property {string} name
 * @param {topicUpdateParams[]} listTranslations
 */
export const topicUpdateTranslations = async (listTranslations) => {
  const result = await Api.post('/Topic/updateTranslation', listTranslations);
  return result;
};

/**
 *
 * @param {string} locationId
 * @param {string} topicId
 * @param {string} searchText
 * @param {string} status
 * @param {string} orderField
 * @param {boolean} ascendingOrder
 * @param {number} pageNumber
 * @param {number} pageSize
 */
export const formGetAll = async (
  locationId = '',
  topicId = '',
  searchText = '',
  status = '',
  orderField = '',
  ascendingOrder = true,
  pageNumber = 0,
  pageSize = 0
) => {
  const result = await Api.post('/Form/getAllSelect', {
    locationId: locationId,
    topicId: topicId,
    searchText: searchText,
    status: status,
    orderField: orderField,
    ascendingOrder: ascendingOrder,
    pageNumber: pageNumber,
    pageSize: pageSize,
  });

  return result;
};

export const userPicker = async (
  locationId = '',
  topicId = '',
  searchText = ''
) => {
  return await Api.post('/User/getUserPicker', {
    locationId,
    topicId,
    searchText,
  });
};

/**
 *
 * @param {string} locationId
 * @param {string} topicId
 * @param {string} searchText
 * @param {string} status
 * @param {string} orderField
 * @param {boolean} ascendingOrder
 * @param {boolean} editAssignedTo
 * @param {number} pageNumber
 * @param {number} pageSize
 */
export const userGetAll = async (
  locationId = '',
  topicId = '',
  searchText = '',
  status = '',
  orderField = '',
  ascendingOrder = true,
  pageNumber = 0,
  pageSize = 0,
  locationDirectParents = false,
  editAssignedTo = false,
  includeProfiles = true
) => {
  return User.getAll({
    locationId: locationId,
    topicId: topicId,
    searchText: searchText,
    status: status,
    orderField: orderField,
    ascendingOrder: ascendingOrder,
    pageNumber: pageNumber,
    pageSize: pageSize,
    locationDirectParents: locationDirectParents,
    editAssignedTo: editAssignedTo,
    includeProfiles: includeProfiles,
  });
};

/**
 * @param {string} entityId
 * @param {import('../pages/FormBuilder/const').ENTITY_TYPE} entityType
 * @param {boolean} withDefaultLanguage
 * @returns { Promise<import('axios').AxiosResponse<{statusCode: number, response: Array<{id: string, name:string, countryCode:string, countryName:string, isDefault: boolean}>}> }
 */
export const getAvailableLanguages = async (
  entityType,
  withDefaultLanguage = true,
  entityId = undefined
) => {
  let result = await Api.post('/Language/getAvailableLanguages', {
    entityId: entityId,
    entityType: entityType,
    withDefaultLanguage: withDefaultLanguage,
  });
  return result;
};

/**
 * @param {string} userId
 */
export const userGetById = async (userId) => {
  const result = await Api.get(`/User/getUserSimpleById?userId=${userId}`);

  return result;
};

/**
 * @param {string} img
 */
export const getUrlImage = async (img) => {
  const r = await Api.get(`/FormTask/getFile/${img}`, {
    responseType: 'blob',
  });
  let url = window.URL.createObjectURL(r.data);
  return url;
};

export const listUpdate = async (body) => {
  const result = await Api.post('/List/update', body);
  return result;
};

export const listSimpleGetAll = async (
  languageId = '',
  locationId = '',
  topicListId = [],
  orderField = '',
  ascendingOrder = true
) => {
  const result = await Api.post('/List/simpleGetAll', {
    languageId: languageId,
    locationId: locationId,
    topicListId: topicListId,
    orderField: orderField,
    ascendingOrder: ascendingOrder,
  });

  return result;
};

export const listGetById = async (id = '', ordering = '') => {
  const result = await Api.get(`/List/get?id=${id}&ordering=${ordering}`);

  return result.data.response;
};

export const listGetByIdSimple = async (
  id = '',
  ordering = '',
  showAtrs = false,
  isFilteringByLocation = false,
  language = null
) => {
  const result = await Api.get(
    `/List/getSimple?id=${id}&languageId=${language}&ordering=${ordering}&showAtrs=${showAtrs}&isFilteringByLocation=${isFilteringByLocation}`
  );

  return result.data.response;
};

export const featureGetAllFiltered = async (featureList = []) => {
  const result = await Api.post('/Feature/getAllFiltered', featureList);

  return result.data;
};

export const getTenant = async () => {
  const result = await Api.get('/Tenant/get', null);

  return result.data;
};

export const updateTenant = (obj) => {
  return Api.post('/Tenant/update', obj);
};

export const roleGetAllFiltered = async (roleList = []) => {
  const result = await Api.post('/Role/getAllFiltered', roleList);

  return result.data;
};

export const featureGetAll = async () => {
  const result = await Api.get('/Feature/getAll');

  return result.data;
};

export const roleGetAll = async () => {
  const result = await Api.get('/Role/getAll');

  return result.data;
};

export const roleDelete = async (roleId) => {
  const result = await Api.post(`/Role/delete?roleId=${roleId}`);

  return result.data;
};

// export const roleInsertOrUpdate = async permissionJsonApi => {
//   let method = permissionJsonApi.id === '' ? 'register' : 'update';
//   const result = await Api.post(`/Role/${method}`, permissionJsonApi);
//   return result;
// };
export const roleInsert = async (permissionJsonApi) => {
  const result = await Api.post(`/Role/register`, permissionJsonApi);
  return result;
};

export const roleUpdate = async (permissionJsonApi) => {
  const result = await Api.post(`/Role/update`, permissionJsonApi);
  return result;
};

export const languageGetAll = async () => {
  const result = await Api.get('/Language/getAll');
  return result;
};

export const FormTaskGet = (id, languageId, relatedTasks) => {
  let params = `?id=${id}`;
  if (languageId) {
    params += `&languageId=${languageId}`;
  }
  if (relatedTasks) {
    params += `&relatedTasks=${relatedTasks}`;
  }
  return Api.get(`/FormTask/get${params}`);
};

export const GetUserRolesById = async (dateTimeNow) => {
  //README: temos de encodar o datetime pois ao enviar expirationDate=2021-07-28T18:58:02+01:00
  // o caracter + é convertido para espaço e acabava ocorrendo erro e deslogando o usuario
  // por isso estamos utilizando o encodeURIComponent.
  dateTimeNow = encodeURIComponent(dateTimeNow);
  const result = await Api.get(
    `/User/getUserRolesById?expirationDate=${dateTimeNow}`
  );
  return result;
};

export const GetUserTasksPending = async (my) => {
  const result = await Api.get(`/FormTask/PendingTasks/${my}`);
  return result;
};

export const FormTaskRegister = (obj) => {
  return Api.post('/FormTask/register', obj);
};

export const FormTaskUpdate = (obj) => {
  return Api.post('/FormTask/update', obj);
};
